import React from 'react';
import PropTypes from 'prop-types';
import { createHashHistory } from 'history';
import { kebabCase, camelCase } from 'lodash';
import { Nav, NavItem, NavLink, Container, Row, Col, Card, CardBody } from 'reactstrap';
const hashHistory = createHashHistory();
const AssetContainer = ({
  children: _children = {},
  section,
  id
}) => {
  const handleSelect = key => hashHistory.replace(`/assets/${id}/${key}`);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-ac-sidebar-title"
  }, "Asset Sections")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
    pills: true,
    vertical: true
  }, ['General', 'Associations', 'Coating Details', 'Detail Descriptions', 'Profile', 'Maintenance', 'Comments', 'Photos'].map((item, index) => /*#__PURE__*/React.createElement(NavItem, {
    active: section.length > 0 ? camelCase(item) === section : index === 0,
    key: `nav-${kebabCase(item)}`,
    className: `t-ac-nav-section-${kebabCase(item)}`
  }, /*#__PURE__*/React.createElement(NavLink, {
    onClick: () => handleSelect(camelCase(item))
  }, item))))))), /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, _children)));
};
AssetContainer.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired
};
export default AssetContainer;